import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimeframeUsageComponent } from './component/timeframe-usage.component';

import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { StructureNodeSelectionModule } from '../../../components/structure-node-selection/structure-node-selection.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StructureNodeSelectionModule,
    CommonTranslationModule,
    CommonUIModule
],
  declarations: [TimeframeUsageComponent]
})
export class TimeframeUsageModule { }
